module.exports = __webpack_public_path__ + "img/枳壳.a425a4ed.jpg";